import type { ProvenanceResponse } from '../services/types';

interface ProvenanceSummaryProps {
  provenance: ProvenanceResponse;
}

export function ProvenanceSummary({ provenance }: ProvenanceSummaryProps) {
  const columns = Object.entries(provenance.by_column);

  if (columns.length === 0) {
    return (
      <p className="text-sm text-muted py-4">
        No transformations were recorded for this run.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <p className="text-xs text-muted">
        {provenance.total_changes} cell{provenance.total_changes === 1 ? '' : 's'} changed
        across {columns.length} column{columns.length === 1 ? '' : 's'}.
      </p>

      <div className="space-y-3">
        {columns.map(([col, entries]) => (
          <div key={col} className="rounded-md border border-border p-4 space-y-2">
            <h3 className="text-sm font-medium font-mono">{col}</h3>
            <ul className="space-y-1">
              {entries.map((e, i) => (
                <li key={i} className="text-sm text-fg flex items-start gap-2">
                  <span className="text-muted text-xs mt-0.5 shrink-0 w-8 text-right">
                    {e.count}×
                  </span>
                  <span>{e.narrative}</span>
                </li>
              ))}
            </ul>
            {entries.some((e) => e.agents.length > 0) && (
              <p className="text-xs text-muted">
                Agents:{' '}
                {[...new Set(entries.flatMap((e) => e.agents))].join(', ')}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
